import { motion } from "framer-motion";
import { ASSETS } from "@/lib/assets";
import StoreBadges from "@/components/StoreBadges";
import PhoneMockup from "@/components/PhoneMockup";
import { OpenAppButton } from "@/components/AppButtons";
import { fadeUp } from "@/components/home/motion";

export default function HeroSection() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={ASSETS.heroBg} alt="" className="h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#121311]/50 via-[#121311]/85 to-[#121311]" />
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 pb-20 pt-28 md:px-10 md:pt-36 lg:grid-cols-12 lg:pb-28">
        <div className="lg:col-span-7">
          <motion.img
            variants={fadeUp} initial="hidden" animate="show"
            src={ASSETS.logoLarge}
            alt="Waidbook"
            data-testid="hero-logo"
            className="mb-8 h-28 w-auto sm:h-36"
          />
          <motion.h1
            variants={fadeUp} initial="hidden" animate="show" custom={1}
            className="font-serif-display text-4xl font-semibold leading-[1.1] text-[#EAEBE7] sm:text-5xl lg:text-6xl"
          >
            Het persoonlijke dossier van de jager.
          </motion.h1>
          <motion.p
            variants={fadeUp} initial="hidden" animate="show" custom={2}
            className="mt-6 max-w-xl text-base leading-relaxed text-[#B5B8B0] md:text-lg"
          >
            Leg je trofeeën en tableau vast, beheer je jachtgebieden en houd
            afschotplan en nazoek bij. Op je telefoon in het veld, en op de
            computer wanneer je meer overzicht wilt.
          </motion.p>
          <motion.p
            variants={fadeUp} initial="hidden" animate="show" custom={2}
            className="mt-4 font-serif-display text-sm italic text-[#8E9189]"
          >
            The hunter's private dossier. Log every trophy. Carry your legacy.
          </motion.p>

          <motion.div
            id="download"
            variants={fadeUp} initial="hidden" animate="show" custom={3}
            className="mt-10 flex flex-col gap-5"
          >
            <OpenAppButton testid="hero-open-waidbook-btn" className="w-full sm:w-fit" />
            <StoreBadges />
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="lg:col-span-5"
        >
          <div className="animate-floaty">
            <PhoneMockup
              testid="hero-phone"
              src={ASSETS.screenLogin}
              alt="Inlogscherm van de Waidbook-app"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
